export default __webpack_public_path__ + "static/media/truck.a3a2fd02.svg";